<template>
    <div class="content_box nopadding mobile_content">
        <div class="top fixed_top el_form">
            <div class="title">
                <span>APP运营报表</span> &nbsp;&nbsp;
                <el-select v-model="region" placeholder="请选择" class="region-select" @change="regionChanged">
                    <el-option label="全部区域" value=""></el-option>
                    <el-option label="美洲数据中心" value="us"></el-option>
                    <el-option label="中国数据中心" value="cn"></el-option>
                    <el-option label="欧洲数据中心" value="eu"></el-option>
                    <el-option label="亚太数据中心" value="ap"></el-option>
                </el-select>
            </div>
            
        </div>
        <div class="area">
            <div class="content app-operation">
                <div class="overview">
                    <div class="overview_left">
                        <div class="title subtitle">
                            <span>概况</span>
                            <el-tooltip popper-class="shadow" effect="light" placement="bottom-start">
                                <div slot="content">
                                    <el-form label-position="left" label-width="180px">
                                        <el-form-item label="今日新增用户">
                                            <span>今日首次注册APP的用户</span>
                                        </el-form-item>
                                        <el-form-item label="今日活跃用户">
                                            <span>今日启动过APP的用户（去重）</span>
                                        </el-form-item>
                                        <!-- <el-form-item label="近30天未活跃用户">
                                            <span>截止当前时间，近30天未活跃的APP用户（即没有打开APP更新数据）</span>
                                        </el-form-item> -->
                                        <el-form-item label="已绑定设备用户数及占比">
                                            <span>统计当前所有绑定了设备的APP用户数及占比</span>
                                        </el-form-item>
                                        <el-form-item label="累计用户数">
                                            <span>截止到当前时间，所有注册APP的用户总数,用户手机系统（安卓用户、iOS用户）占比</span>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                            </el-tooltip>
                        </div>
                        <div class="time">{{'数据时间 ' + formDate((new Date()).getTime(),'YYYY-MM-DD HH:mm')}}</div>
                        <div class="overview_box">
                            <div class="overview_item">
                                <p class="name">今日新增用户</p>
                                <p class="number">{{formatNumber(overviewData.create_count || 0)}}</p>
                                <p class="compared">
                                    <span>昨日同期</span> &nbsp;
                                    <span class="num" :class="overviewData.create_rate > 0 ? 'num2' : (overviewData.create_rate < 0 ? 'num3' : '')">
                                        {{overviewData.create_rate ?  overviewData.create_rate + '%' : '-'}}
                                    </span>
                                    <img class="ico" v-if="overviewData.create_rate < 0" src="../../../assets/images/ico/down.png" alt="">
                                    <img class="ico" v-if="overviewData.create_rate > 0" src="../../../assets/images/ico/up.png" alt="">
                                </p>
                            </div>
                            <div class="overview_item">
                                <p class="name">今日活跃用户</p>
                                <p class="number">{{formatNumber(overviewData.active_count || 0)}}</p>
                                <p class="compared">
                                    <span>昨日同期</span> &nbsp;
                                    <span class="num" :class="overviewData.active_rate > 0 ? 'num2' : (overviewData.active_rate < 0 ? 'num3' : '')">
                                        {{overviewData.active_rate ?  overviewData.active_rate + '%' : '-'}}
                                    </span>
                                    <img class="ico" v-if="overviewData.active_rate < 0" src="../../../assets/images/ico/down.png" alt="">
                                    <img class="ico" v-if="overviewData.active_rate > 0" src="../../../assets/images/ico/up.png" alt="">
                                </p>
                            </div>
                            <!-- <div class="overview_item">
                                <p class="name">近30天未活跃用户</p>
                                <p class="number">{{formatNumber(overviewData.no_act_count || 0)}}</p>
                            </div> -->
                            <div class="overview_item">
                                <p class="name">已绑定设备用户数</p>
                                <p class="number">{{formatNumber(overviewData.bind_count || 0)}}</p>
                                <p class="compared">
                                    <span>绑定占比</span> &nbsp;
                                    <span class="num rate">
                                        {{overviewData.bind_rate ? overviewData.bind_rate: '-'}}
                                    </span>
                                </p>
                            </div>
                            <div class="overview_item">
                                <p class="name">累计用户数</p>
                                <p class="number">{{formatNumber(overviewData.user_sum || 0)}}</p>
                                <div class="system">
                                    
                                    <div class="system_box">
                                        <p class="ios" :style="{width: (overviewData.ios_count || overviewData.ard_count) ? (overviewData.ios_count/(overviewData.ios_count + overviewData.ard_count) * 100) + '%' : '50%'}"></p>
                                        <p class="android"></p>
                                    </div>
                                    <div class="system_type">
                                        <span>{{'ios(' + ((overviewData.ios_count || overviewData.ard_count) ? (overviewData.ios_count/(overviewData.ios_count + overviewData.ard_count) * 100).toFixed(2) + '%' : '50%') + ')' }}</span>
                                        <span>{{'安卓(' + ((overviewData.ios_count || overviewData.ard_count) ? (overviewData.ard_count/(overviewData.ios_count + overviewData.ard_count) * 100).toFixed(2) + '%' : '50%') + ')'}}</span>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overview_right">
                        <div class="title subtitle">
                            <span>智能音箱用户数</span>
                            <span class="number">{{formatNumber((overviewData.both_count || 0) + (overviewData.only_alexa_count || 0) + (overviewData.only_ghome_count || 0))}}</span>
                        </div>
                        <div class="smart_audio">
                            <div class="smart_audio_echart" ref="smart_audio_echart"></div>
                        </div>
                    </div>
                </div>
                <div class="trend distribute">
                    <div class="trend_box">
                        <div class="top padding">
                            <div class="title subtitle">
                                <span>用户分布分析</span>
                            </div>
                            <div class="search_box">
                                <el-form label-position="left" :label-width="$store.state.type == 'pc' ? '100px' : '70px'">
                                    <el-form-item label="统计指标">
                                        <el-radio-group v-model="distributeType" size="small">
                                            <el-radio-button label="create">新增用户数</el-radio-button>
                                            <el-radio-button class="radio_button_w" label="active">活跃用户数（近30天）</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="日期选择" v-show="distributeType == 'create'">
                                        <DatePicker :date="distributeTime" :disabled="distributeType == 'active'" @dateSelect="distributeTimeSelect"></DatePicker>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                        <div class="padding echart_box">
                            <div class="echart_item">
                                <div class="title subtitle">国家/地区分布</div>
                                <div class="echart" ref="country_echart"></div>
                                <span class="no_data" v-show="distributeType == 'active' ? distributeActiveData.country_list && distributeActiveData.country_list.length == 0 : distributeData.country_list && distributeData.country_list.length == 0">暂无数据</span>
                            </div>
                            <div class="echart_item">
                                <div class="title subtitle">
                                    <span>城市分布</span>
                                    <el-select v-model="distributeCountry" clearable size="medium" placeholder="国家/地区" @change="countryChange">
                                        <el-option :label="item" :value="item" v-for="item in countryData" :key="item + '12113'"></el-option>
                                    </el-select>
                                </div>
                                <div class="echart" ref="city_echart"></div>
                                <span class="no_data" v-show="distributeType == 'active' ? distributeActiveData.city_list && distributeActiveData.city_list.length == 0 : distributeData.city_list &&  distributeData.city_list.length == 0">暂无数据</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="trend">
                    <div class="trend_box">
                        <div class="top padding">
                            <div class="title subtitle">
                                <span>新增/活跃用户趋势</span>
                            </div>
                            <div class="search_box">
                                <el-form label-position="left" :label-width="$store.state.type == 'pc' ? '100px' : '70px'">
                                    <el-form-item label="统计指标">
                                        <el-radio-group v-model="trendType" size="small">
                                            <el-radio-button label="create">新增用户数</el-radio-button>
                                            <el-radio-button label="active">活跃用户数</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="日期选择">
                                        <DatePicker :date="trendTime" max="120" @dateSelect="dateSelect"></DatePicker>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                        <div class="line" v-if="$store.state.type == 'pc'"></div>
                        <div class="padding line_echart">
                            <div class="select_show_type">
                                <el-radio-group v-model="getTrendData.data_type" size="small">
                                    <el-radio-button label="TypeDay">日</el-radio-button>
                                    <el-radio-button label="TypeWeek" :disabled="!(selectType > 1)">周</el-radio-button>
                                    <el-radio-button label="TypeMonth" :disabled="!(selectType > 2)">月</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="echart_line_area data_area">
                                <div class="line_box" ref="line_echart">

                                </div>
                                <div class="dataNone line_none" v-show="this.trendData.length == 0">暂无数据</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="trend">
                    <div class="trend_table">
                        <div class="title subtitle title-1">
                            <span>数据明细</span>
                        </div>
                        <div class="line" v-if="$store.state.type == 'pc'"></div>
                        <el-table
                            highlight-current-row
                            :data="trendTableData">
                            <el-table-column prop="time_info" label="日期" ></el-table-column>
                            <el-table-column prop="create" label="新增用户数" >
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.create)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="active" label="活跃用户数" >
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.active)}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <Pagination :total="trendData.length" :page="page" @paginationChange="initTableData"></Pagination>
                    </div>  
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import resize  from "../../../minxins/resize"
export default({
    name: 'app-operation',
    mixins: [resize],
    data() {
        return {
            region: '',
            overviewData: {},
            distributeTime: [],
            distributeType: 'create',
            getDistributeData: {
                start_time: 0,
                end_time: 0
            },
            distributeCountry: '',
            distributeData: [],
            distributeActiveData: [],
            countryData: [],
            trendTime: [],
            trendType: 'create',
            selectType: 3,
            getTrendData: {
                start_time: 0,
                end_time: 0,
                data_type: 'TypeDay'
            },
            trendData: [],
            trendTableData: [],
            page_size: 10,
            page: 1,
            total: 0,
        }
    },
    watch: {
        'distributeTime' : function (nTime, oTime) {
            this.getDistributeData.start_time = this.formDate(nTime[0], 'YYYY-MM-DD');
            this.getDistributeData.end_time = this.formDate(nTime[1], 'YYYY-MM-DD');
            this.distributeCountry = '';
            this.getUserRegion();
        },
        'trendTime' : function (nTime, oTime) {
            if(nTime[1] - nTime[0] < 86400000 * 7) { //选择7天内 
                this.selectType = 1;
                this.getTrendData.data_type = 'TypeDay';
            }else if(nTime[1] - nTime[0] < 86400000 * 30) { //选择30天内 
                this.selectType = 2;
                if(this.getTrendData.data_type == 'TypeMonth') {
                    this.getTrendData.data_type = 'TypeWeek';
                }
            }else{
                this.selectType = 3;
            }
            this.getTrendData.start_time = this.formDate(nTime[0], 'YYYY-MM-DD');
            this.getTrendData.end_time = this.formDate(nTime[1], 'YYYY-MM-DD');
            this.getAppTrend();
        },
        distributeType: function() {
            this.initBar();
        },
        trendType: function() {
            this.initLine();
        },
        'getTrendData.data_type': function() {
            this.getAppTrend();
        }
    },
    created() {
        this.region = this.$route.query.region || this.region;
        this.getAppData();
        this.distributeTime = this.setDate(30);
        this.trendTime = this.setDate(30);
    },
    methods: {
        regionChanged(val) {
            this.region = val;
            this.$router.replace('?region=' + val);
            this.overviewData = {};
            this.trendData = [];
            this.total = 0;
            this.distributeCountry = '';
            this.getAppData();
            this.getAppTrend();
            this.getUserRegion();
        },
        countryChange(){
            this.initBar();
        },
        getAppData() {
            this.api.getAppData({zone: this.timezone}).then(data => {
                this.overviewData = data.data.result;
                this.innitSmartAudioPie();
            })
        },
        getUserRegion() {
            Promise.all([this.api.getUserRegion(this.getDistributeData), this.api.getUserRegionActive({})]).then(res => {
                this.distributeData = res[0].data.data_list.create;
                this.distributeActiveData = res[1].data.data_list.active;
                this.initBar();
            });
        },
        getAppTrend() {
            this.api.getAppTrend(this.getTrendData).then(data => {
                this.trendData = data.data.data_list;
                this.initLine();
                this.initTableData({page_size: this.page_size, page: 1});
            })
        },
        distributeTimeSelect(date) {
            this.distributeTime = [...date];
        },
        dateSelect(date) {
            this.trendTime = [...date];
        },
        initTableData(data) {
            this.trendTableData = [];
            this.page = data.page;
            this.page_size = data.page_size;
            for(let i=(data.page_size * (data.page - 1)); i<this.trendData.length; i++) {
                this.trendTableData.push(this.trendData[i]);
                if(this.trendTableData.length == data.page_size) break;
            }
        },
        initEcharts() {
            var countryChart = this.echarts.init(this.$refs.country_echart);
            countryChart.resize();
            var cityChart = this.echarts.init(this.$refs.city_echart);
            cityChart.resize();
            var lineChart = this.echarts.init(this.$refs.line_echart);
            lineChart.resize();
        },
        innitSmartAudioPie() {
            var smartAudioChart = this.echarts.init(this.$refs.smart_audio_echart);
            smartAudioChart.clear();
            smartAudioChart.setOption(this.smartAudioOption());
        },
        initBar() {
            let countryX = [], countryV = [];
            let cityX = [], cityV = [];
            let distributeData = this.distributeType == 'create' ? this.distributeData : this.distributeActiveData;
            let country = [...distributeData.country_list];
            country.sort((a,b) => {
                return b.count - a.count;
            })
            this.countryData = [];
            country.forEach(item => {
                if(item.country != '0') {
                    this.countryData.push(item.country);
                }
                countryX.push(item.country == '0' ? '其他' : item.country);
                countryV.push(item.count);
            })

            if(this.distributeCountry) {
                let cityData = distributeData.city_list[this.distributeCountry] || [];
                cityData.forEach(item => {
                    cityX.push(item.city == '0' ? '其他' : item.city);
                    cityV.push(item.count);
                })
            }else{
                let cityData = distributeData.city_list.all || [];
                cityData.forEach(item => {
                    cityX.push(item.city == '0' ? '其他' : item.city);
                    cityV.push(item.count);
                })
            }
            const countryChart = this.echarts.init(this.$refs.country_echart);
            countryChart.clear();
            countryChart.setOption(this.setBarOption(countryX,countryV));

            const cityChart = this.echarts.init(this.$refs.city_echart);
            cityChart.clear();
            cityChart.setOption(this.setBarOption(cityX,cityV));
        },
        initLine() {
            let xData = [], yData = [];
            this.trendData.forEach(item => {
                xData.push(item.time_info);
                yData.push(item[this.trendType]);
            })
            xData.reverse();
            yData.reverse();
            var lineChart = this.echarts.init(this.$refs.line_echart);
            lineChart.clear();
            lineChart.setOption(this.lineOption(xData, yData));
        },
        smartAudioOption() {
            return {
				color: ['#00D6B9','#F8AF0C', '#507FF7'],
                grid: {
                    top: 10,
                    bottom: 10
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'horizontal',
                    bottom: 0,
                    itemWidth: 12,
                    itemHeight: 12,
                    icon: "rect",
                    itemGap: 16,
                    selectedMode: false,
                },
                series: [
                    {
                        name: '智能音箱用户数',
                        type: 'pie',
                        center: this.$store.state.type == 'pc' ? ['50%', '90px'] : ['50%', '100px'],
						label: {
							show: false,
						},
                        data: [{
                            name: '仅关联Alexa',
                            value: this.overviewData.only_alexa_count
                        },{
                            name: '仅关联Google Home',
                            value: this.overviewData.only_ghome_count
                        },{
                            name: '同时关联两个品牌',
                            value: this.overviewData.both_count
                        }]
                    }
                ]
            };
        },
        setBarOption(key, value, ) {
			return {
				color: ['#507FF7'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					}
				},
				grid: {
					left: this.$store.state.type == 'pc' ? '100' : '20',
					right: '40',
					top: '20',
					bottom: '10',
					containLabel: true
				},
				xAxis: {
					type: 'value',
					name: key.length > 0 ? '用户数' : '',
					splitNumber: 5,
					nameLocation: 'start',
                    nameGap: 10,
					nameTextStyle: {
                        verticalAlign: 'top',
                        padding: [8, 0, 0, 0]
					},
					splitLine: {
						show: false
					},
					axisLabel: {
						color: '#868998',
						formatter: function(value, index) {
                            if(Math.abs(value/1000000) >= 1) {
                                return value/1000000 + 'M';
                            }else if(Math.abs(value/1000) >= 1) {
                               return value/1000 + 'K';
                            }
                            return value;
                        }
					},
				},
				yAxis: [{
					type: 'category',
					inverse: true,
					axisTick: {
						show: false
					},
                    axisLine: {
						show: false
					},
					axisLabel: {
						color: '#868998'
					},
					data: key
				}],
				dataZoom: key.length <= 10 ? null :{
					type: 'slider',
					yAxisIndex: 0,
					start: 0,
                    end: 100,
					maxValueSpan: 10,
					width: 14,
					brushSelect: false,
					backgroundColor: '#f7f8fa',
					borderColor: '#ebeef5',
					fillerColor: '#e6e9f0',
					showDataShadow: false,
					showDetail: false
				},
				series: {
					name: '用户数',
					type: 'bar',
                    barMaxWidth: 20,
					label: {
						show: true,
						color: '#000',
						align: 'left',
						fontSize: 10,
                        offset: [10, 0],
						formatter: (p) => {
							return this.formatNumber(p.value);
						}
					},
					data: value
				}
			}
		},
        lineOption(xData, yData) {
            return {
                grid: this.$store.state.type == 'pc' ? {
                    left: 20,
                    top: 40,
                    bottom: 10,
                    right: 40,
                    containLabel: true
                } :  {
                    left: 20,
                    top: 40,
                    bottom: 10,
                    right: 20,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData,
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        formatter: (item, index) => {
                            if(this.$store.state.type == 'pc') {
                                return item.split('~')[item.split('~').length - 1];
                            }else{
                                return item.split('~')[item.split('~').length - 1].substr(5);
                            }
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    splitNumber: 5,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        formatter: function(value, index) {
                            if(value/1000000 >= 1) {
                                return value/1000000 + 'M';
                            }else if(value/1000 >= 1) {
                               return value/1000 + 'K';
                            }
                            return value;
                        }
                    }
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    backgroundColor: 'rgba(255,255,255,.9)',
                    orderWidth: 0,
                    textStyle: {
                        color: '#333'
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            type: 'solid',
                            color: 'rgba(200,200,200,.4)'
                        }
                    },
                    formatter: (n) => {
                        return `${n[0].name} <br /> ${this.trendType == 'create' ? '新增用户数' : '活跃用户数'}: ${this.formatNumber(n[0].value)}`;
                    }
                },
                dataZoom: this.$store.state.type == 'pc' ? null : {
                    type: 'inside',
                    start: 0,
                    end: 100
                },
                series: [
                    {
                        data: yData,
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        lineStyle: {
                            color: '#5192FF',
                            width: 1
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y:1,
                                x2: 0,
                                y2: 0,
                                colorStops: [{
                                    offset: 0, color: '#FFFFFF' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#507FF7' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        }
                    }
                ]
            }
        }
    }
})
</script>
<style lang="less" scoped>
    @import '../../../less/statistics.less';
    .content{
        .overview{
            background: none;
            padding: 0;
            overflow: hidden;
            .flexLayout(space-between);
            & > div{
                padding: 30px;
                background: #fff;
                border-radius: 24px;
            }
            .overview_left{
                flex: 1;
                margin-right: 20px;
                .time{
                    margin-bottom: 50px;
                }
            }
            .overview_right{
                width: 436px;
                height: 258px;
                padding-bottom: 10px;
                box-sizing: border-box;
                .title{
                    .number{
                        font-size: 20px;
                        margin-left: 10px;
                    }
                }
                .smart_audio{
                    .smart_audio_echart{
                        height: 190px;
                    }
                }
            }
            @media (max-width: 768px) {
                display: block;
                .overview_left{
                    margin-bottom: 20px;
                    margin-right: 0;
                    padding: 20px;
                    .time{
                        margin-bottom: 20px;
                    }
                }
                .overview_right{
                    width: 100%;
                    height: 320px;
                    padding-bottom: 20px;
                    .smart_audio{
                        .smart_audio_echart{
                            height: 250px;
                        }
                    }
                }
            }
        }
    }
    .overview_box{
        .rate{
            color: @colorBlue2;
        }
        .system{
            width: 160px;
            .system_box{
                flex: 1;
                height: 12px;
                border-radius: 6px;
                background: #73EFE5;
                font-size: 10px;
                margin: 0 5px;
                overflow: hidden;
                .flexLayout();
                p{
                    height: 100%;
                    line-height: 12px;
                    color: #fff;
                    &.ios{
                        background: #507FF7;
                        border: 0 6px 6px 0;
                    }
                    &.android{
                        flex: 1;
                    }
                }
            }
            .system_type{
                font-size: 12px;
                .flexLayout();
                flex-wrap: nowrap;
                justify-content: space-between;
                color: #868998;
            }
        }
        @media(max-width: 768px) {
            justify-content: flex-start!important;
            .overview_item{
                width: 50%;
                margin: 20px 0;
                .system{
                    width: 100%;
                    font-size: 10px;
                }
                @media(max-width: 400px) {
                    width: 49%;
                }
            }
        }
        
    }
    .distribute{
        .echart_box{
            .flexLayout(flex-start);
            .echart_item{
                width: 50%;
                position: relative;
                .title{
                    padding-left: 80px;
                    margin-top: 20px;
                    font-size: 14px;
                    /deep/ .el-select{
                        width: 150px;
                        margin-left: 20px;
                        .el-input--medium .el-input__inner{
                            height: 28px;
                            line-height: 28px;
                        }
                        .el-input__icon{
                            line-height: 28px;
                        }
                    }
                }
                .echart {
                    width: 100%;
                    max-width: 500px;
                    height: 300px;
                }
                .no_data{
                    position: absolute;
                    top: 40%;
                    left: 40%;
                    color: @colorGray;
                }
                .city_echart{
                    margin-left: 10vw;
                }
            }
        }
        @media(max-width: 768px) {
            .echart_box{
                .echart_item{
                    width: 100%;
                    max-width: none;
                    .title{
                        padding-left: 0;
                        margin-top: 20px;
                        font-size: 0.12rem;
                    }
                    .echart{
                        max-width: 100%;
                    }
                    .city_echart{
                        margin-left: 0;
                    }
                }
            }
        }
    }
    @media (max-width: 768px) {
        /deep/.mobile_content .el-radio-button--small .el-radio-button__inner {
            width: 120px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/statistics/app/app-operation.vue